import { ApplicationContext, Environment } from './shared-types'

import environmentUtils from '@app/utils/environment'

export default (appContext: ApplicationContext): ApplicationContext => {
  appContext.environment = environmentUtils.__DEV__
    ? Environment.Development
    : environmentUtils.__TEST__
    ? Environment.Test
    : Environment.Production

  return appContext
}
